import React, { useContext } from 'react'
import Chrome, { ChromeProps } from '../Chrome'
import { IdentityContext } from '#src/containers/Identity'
import { useRecommendExpert2Query, useExpertByCategoryQuery } from '#src/generated/graphql'

interface ChromeWithCategorySidebarProps extends ChromeProps {
  categoryId?: string
}

const ChromeWithCategorySidebar: React.SFC<ChromeWithCategorySidebarProps> = ({
  categoryId,
  ...props
}) => {
  const { myself } = useContext(IdentityContext)
  const { data: loggedInExpertData } = useRecommendExpert2Query({
    variables: { categoryId: categoryId!, consumerId: myself && myself!.id },
    skip: !myself || !categoryId
  })

  const { data: loggedOutExpertData } = useExpertByCategoryQuery({
    variables: {
      categoryId: categoryId!
    },
    skip: !!(myself || !categoryId)
  })

  // The recommended expert to talk to for this category
  const recommendedExpert = loggedInExpertData && loggedInExpertData.recommendExpert2.expert

  // If you already have a lead with a conversation, we'll re-use that conversation
  const existingConversationId = recommendedExpert?.existingLeadForConsumer?.conversation.externalId
  const categoryExpert = loggedOutExpertData?.category.recommendExpertForConsumer.expert

  if (myself) {
    return (
      <Chrome
        sidebar={true}
        chatConversationId={existingConversationId || undefined}
        chatExpertId={recommendedExpert && recommendedExpert.id}
        {...props}
      />
    )
  } else {
    return (
      <Chrome
        sidebar={true}
        chatRecipientIds={categoryExpert ? [categoryExpert.id] : undefined}
        chatExpertId={categoryExpert ? categoryExpert.id : undefined}
        {...props}
      />
    )
  }
}

export default ChromeWithCategorySidebar
